import { sandboxBaseGameQuery } from "/app/src/routes/{-$locale}/changelog/$id.tsx?tsr-shared=1";
import * as React from "react";
import { HydrationBoundary, useQuery } from "@tanstack/react-query";
import { httpClient } from "@/lib/http-client";
import { ChangeTracker } from "@/components/app/changelog/item";
import { useTranslation } from "@/lib/paraglide-react";
type ChangeResponse = OfferHit | ItemHit | AssetHit | Hit;
interface DefaultHit {
  _id: string;
  timestamp: string;
  metadata: Metadata;
}
interface Metadata {
  changes: Change[];
  contextId: string;
  contextType: string;
  context: SingleOffer | SingleItem | null;
}
interface Change {
  changeType: "insert" | "update" | "delete";
  field: string;
  newValue: unknown;
  oldValue: unknown;
}
interface OfferHit extends DefaultHit {
  metadata: Metadata & {
    contextType: "offer";
    context: SingleOffer;
  };
}
interface ItemHit extends DefaultHit {
  metadata: Metadata & {
    contextType: "item";
    context: SingleItem;
  };
}
interface AssetHit extends DefaultHit {
  metadata: Metadata & {
    contextType: "asset";
    context: SingleItem;
  };
}
interface Hit {
  _id: string;
  timestamp: string;
  metadata: Metadata;
}
import { Route } from "/app/src/routes/{-$locale}/changelog/$id.tsx";
function ChangeDetailPage() {
  const {
    t
  } = useTranslation();
  const {
    id
  } = Route.useLoaderData() as {
    dehydratedState: DehydratedState;
    id: string;
  };
  const {
    data,
    isLoading,
    isError
  } = useQuery({
    queryKey: ["changelog", id],
    queryFn: () => httpClient.get<ChangeResponse>(`/changelist/${id}`)
  });
  useQuery({
    ...sandboxBaseGameQuery(data?.metadata.context?.namespace),
    enabled: !!data?.metadata.context?.namespace
  });
  if (isLoading) {
    return <div className="flex flex-col gap-6 w-full max-w-6xl mx-auto px-4 py-8 sm:px-6">
        <div>{t("changelog.detail.loading")}</div>
      </div>;
  }
  if (isError) {
    return <div className="flex flex-col gap-6 w-full max-w-6xl mx-auto px-4 py-8 sm:px-6">
        <div>{t("changelog.detail.error")}</div>
      </div>;
  }
  if (!data) {
    return <div className="flex flex-col gap-6 w-full max-w-6xl mx-auto px-4 py-8 sm:px-6">
        <div>{t("changelog.detail.notFound")}</div>
      </div>;
  }
  return <div className="flex flex-col gap-6 w-full max-w-6xl mx-auto px-4 py-8 sm:px-6">
      <div className="grid gap-4">
        <ChangeTracker key={data._id} {...{
        _id: data._id,
        document: data.metadata.context,
        metadata: data.metadata,
        timestamp: data.timestamp
      } as Parameters<typeof ChangeTracker>[0]} />
      </div>
    </div>;
}
const SplitComponent = () => {
  const {
    dehydratedState
  } = Route.useLoaderData() as {
    dehydratedState: DehydratedState;
    id: string;
  };
  return <HydrationBoundary state={dehydratedState}>
        <ChangeDetailPage />
      </HydrationBoundary>;
};
export { SplitComponent as component };